import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as CoreUIThemeProvider } from '@hopskipdrive/react-components';
import { LicenseInfo } from '@mui/x-license-pro';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { useCsrfQuery } from './auth/hooks/useCsrfQuery';
import { AxiosErrorBoundary } from './shared/api/utils/AxiosErrorBoundary';
import { theme, ThemeProvider as CareConsoleThemeProvider } from './shared/components/theme';
import { AlertsDetectOriginProvider } from './shared/contexts/AlertsDetectOriginContext';
import { LoaderProvider } from './shared/contexts/LoaderContext';
import { ToastProvider } from './shared/contexts/ToastContext';
import { ErrorBoundary } from './shared/utils/errorReporting/ErrorBoundary';
import Routes from './routes';

const queryClient = new QueryClient();

LicenseInfo.setLicenseKey(window.env?.CARE_MUI_PRO_LICENSE_KEY);

export const App = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AxiosErrorBoundary>
            <CoreUIThemeProvider customTheme={theme}>
              <CareConsoleThemeProvider>
                <ToastProvider>
                  <AlertsDetectOriginProvider>
                    <LoaderProvider>
                      <Services>
                        <ReactQueryDevtools initialIsOpen />
                        <Routes />
                      </Services>
                    </LoaderProvider>
                  </AlertsDetectOriginProvider>
                </ToastProvider>
              </CareConsoleThemeProvider>
            </CoreUIThemeProvider>
          </AxiosErrorBoundary>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

const Services = ({ children }) => {
  useCsrfQuery();

  return children;
};
